import { z } from 'zod'
import type { KdsMobileAppSetting } from '../../models/AppSetting'

export const KdsMobileAppSettingDTO = z.object({
  kds_id: z.number().nullish()
})

export type KdsMobileAppSettingDTO = z.infer<typeof KdsMobileAppSettingDTO>

export function mapDTOToKdsMobileAppSetting (dto: KdsMobileAppSettingDTO): KdsMobileAppSetting {
  return {
    kdsId: dto.kds_id ?? undefined
  }
}

export function mapKdsMobileAppSettingToDTO (model: KdsMobileAppSetting): KdsMobileAppSettingDTO {
  return {
    kds_id: model.kdsId ?? null
  }
}
